export default __webpack_public_path__ + "static/medical-3e925fc67a620e488277af5b7af9d507.png";